import { CommonModule } from '@angular/common';
import { Component, Injector, OnInit } from '@angular/core';
import {
  CustomerDeliveryNoteListDto,
  CustomerDeliveryNoteService,
} from '@digiwall/goliath-documents/proxy';
import {
  DwGridDataSourceService,
  FieldTypes,
  IEnumerationCellRendererParams,
} from '@digiwall/ag-grid';
import { ActivatedRoute, Router } from '@angular/router';
import { LocalizationService, SubscriptionService, LocalizationModule } from '@abp/ng.core';
import { ConfirmationService } from '@abp/ng.theme.shared';
import { ColDef } from '@ag-grid-community/core';
import { BaseCustomerDocList } from '../../base-customer-docs/base-customer-doc-list';
import { ListPageComponent } from '@digiwall/ag-grid';
import { AgGridComponent } from '@digiwall/ag-grid';

@Component({
  selector: 'document-customer-delivery-note-list',
  templateUrl: './customer-delivery-note-list.component.html',
  styles: `
    :host {
      flex-grow: 1;
    }
  `,
  providers: [DwGridDataSourceService, SubscriptionService],
  imports: [CommonModule, ListPageComponent, AgGridComponent, LocalizationModule],
})
export class CustomerDeliveryNoteListComponent
  extends BaseCustomerDocList<CustomerDeliveryNoteListDto, CustomerDeliveryNoteService>
  implements OnInit
{
  private _columns: ColDef[] = [
    ...this.colDefs,
    {
      field: 'deliveryDate',
      headerName: this.localizationService.instant('Doc::CustomerDeliveryNote:DeliveryDate'),
      type: FieldTypes.Date,
      hide: true,
    },
    {
      field: 'isInvoiced',
      headerName: this.localizationService.instant('Doc::CustomerDeliveryNote:IsInvoiced'),
      type: FieldTypes.Enumeration,
      cellRendererParams: {
        entities: this.documentEnumerationTypeStore.invoicedStatus,
      } as IEnumerationCellRendererParams,
      hide: true,
    },
    {
      field: 'deliveryNoteStatus',
      headerName: this.localizationService.instant('Doc::CustomerDeliveryNote:DeliveryNoteStatus'),
      type: FieldTypes.Enumeration,
      cellRendererParams: {
        entities: this.documentEnumerationTypeStore.deliveryNoteStatus,
      } as IEnumerationCellRendererParams,
    },
    {
      field: 'isSigned',
      headerName: this.localizationService.instant('Doc::CustomerDeliveryNote:Signed'),
      type: FieldTypes.Boolean,
      hide: true,
    },
  ];

  get columns(): ColDef[] {
    return this._columns;
  }

  constructor(
    customerInvoiceService: CustomerDeliveryNoteService,
    router: Router,
    route: ActivatedRoute,
    localizationService: LocalizationService,
    subscriptionService: SubscriptionService,
    confirmation: ConfirmationService,
    datasource: DwGridDataSourceService,
    injector: Injector,
  ) {
    super(
      customerInvoiceService,
      router,
      route,
      localizationService,
      subscriptionService,
      confirmation,
      datasource,
      injector,
    );

    // Default view: minimal columns, plus the delivery locality for delivery notes.
    this.applyDefaultColumnVisibility();
    this.showColumns('thirdPartyLocality');
    this._columns = this.orderColumns(this._columns, [
      'displayNumber',
      'documentDate',
      'isClosed',
      'thirdPartyCode',
      'thirdPartyName',
      'thirdPartyLocality',
      'reference',
      'totalAmount',
      'deliveryNoteStatus',
    ]);
    this.applyColumnWidths(
      {
        displayNumber: 110,
        documentDate: 150,
        isClosed: 110,
        thirdPartyCode: 150,
        thirdPartyName: 200,
        thirdPartyLocality: 150,
        totalAmount: 110,
        deliveryNoteStatus: 150,
      },
      'reference',
      180,
    );
  }
}
